module.exports = Function.call.bind(Object.prototype.hasOwnProperty);



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/prop-types@15.8.1/~/prop-types/lib/has.js
// module id = 28
// module chunks = 0